
import React from 'react';

import ReactDOM from 'react-dom';
 
 
import { Upload, Modal,Button,IconFont } from '@jd/find-react';
import { PlusOutlined, InboxOutlined } from '@ant-design/icons';
import KeeVue from '../base/KeeVue.js'

const { Dragger } = Upload;
 
export default class FsUpload1 extends KeeVue {
	constructor(props) {
		super(props);
		
		var token = this.getCookie("token");
		

		this.state = {
			isShow: false,
			randId: this.getRandString(),
			actionUrl: (window.fileUrl + '/keeUploadFile/add?') + "id=" + this.props.component.id + "&tid=" + window.tid + "&token=" + token,
			nodes:[ ],
			fileList: [ ],

		}

	}

	componentDidMount() {
		var that = this;
		this.registComponent();
		this.initFiles(this.props.component.value);
		  
	}
	
	shouldComponentUpdate(nextProps, nextState) {
		
		if(nextProps.component.value!=this.value)
		{
			this.initFiles(nextProps.component.value)
		}
	 
		 
		return true;
	
	   
	}
		initFiles=(value)=> {
					var that = this;
				 
					var retIds = value;
					
					this.value =  value;
	
					that.imageUrl = null;
					if((retIds)) {
						
						if(retIds instanceof Array) 
						{
							that.state.fileList=[];
							retIds.map((item,index)=>{
								
								that.state.fileList.push({
									name:item.filename, 
									status: 'done', 
									uid:this.getRandString(),
									id:this.getRandString(), 
									url:item.downloadPath
								})
							})
							
							that.refresh();
						}
						else
						{
							if(retIds.indexOf("//") != -1) {
								 
							}
							
							else {
								// 从服务器获取原始信息
								
								var picIds = retIds.split(",");
								
								// 针对多个图片的展示；
								
								this.doRequest(window.fileUrl + '/keeUploadFile/getByIds?ids=' + retIds + '&fields=id,tname,sysUser.name,createTime,oldName,path,fileType,fileSize,isTemp', function(files) {
								
									if(files == null || files.success == false) {
										return;
									}
									console.log("---------------");
									console.log(JSON.stringify(files));
									
									that.state.fileList=[];
									files.map((item,index)=>{
										
										that.state.fileList.push({
											name:item.oldName,
											id:item.id,
											status: 'done',
											uid:item.id,
											url:window.fileUrl+"/api/fs/getById?ids="+item.id
										})
									})
									
									that.refresh();
									
								
								 
								 
								
								}, {
									isDel: that.isDel,
									sort: 'seq',
									order: 'asc'
								});
							}
						}
						
						
	
					} else {
						
						this.state.fileList=[]; 
						this.refresh();
						
					}
	
				}
				

	  handleChange = ({ fileList }) =>{ 
		
		  console.log("----handleChange----");
		  console.log(JSON.stringify(fileList));
		  // 设置ids
		  var ids = "";
		  if(fileList)
		  {
			   fileList.map((item,index)=>{
//				console.log("---------");
//				console.log(item);
				if(item.status!="done")
				{
                    return;
				}
				if(!item.id&&item.response)
				{
					item.id = item.response.id;
					item.name = item.response.oldName;
				}
				  
				if(!item.url&&item.id)
				{
					item.url = window.fileUrl+"/api/fs/getById?ids="+item.id;
					
				}
				
				if(item.id)
				{
					if(ids)
					ids+=",";
					ids+=item.id;
				}
				  
			  })
		  }

          console.log("ids---");
          console.log(ids);
		  if(ids)
		  {
		     this.$emit("change",ids);
		  }
          this.state.fileJson = JSON.stringify(fileList);
          this.setState({ fileList })

		  this.refresh();

	  }
	  
	  handlePreview = (file) => {
		  
		  
		  
		  if(file.name.indexOf(".png") != -1 || file.name.indexOf(".jpg") != -1 || file.name.indexOf(".jpeg") != -1 || file.name.indexOf(".gif") != -1) {
		  											file.isImg = true;
		  										 
		  										} else {
		  											file.isImg = false;
		  										}
												
		  
		  if(file.isImg == true) {
		  					window.$.fancybox.open(file.url);
		  				} else {
		  					// 下载文件  参考 http://blog.csdn.net/wyc111/article/details/47613465
		  					var url = file.downloadUrl;
		  
		  				 
		  
		  					//alert("生效了吗？" + url)
		  					window.$.fileDownload(file.url, {
		  						data: {},
		  						successCallback: function(url) {
		  
		  							window.showMessage("文件下载成功！")
		  
		  						},
		  						failCallback: function(html, url) {
		  							alert("导出失败，未知异常。" + html);
		  
		  						}
		  					});
		  				}
		  
		  
	  };
	  

	render() {
		const {accept, listType} = this.props.component.cp;

		const acceptStr = (accept && accept.split(',')) || '';

//		console.log(this.state.fileList);
//        console.log(this.state.actionUrl);
//		console.log("-----acceptStr------");
//		console.log(listType);
//		console.log(acceptStr);
//		console.log(this.props.component.cp.description);
	    const uploadButton = (
	       <div>
	         <PlusOutlined />
	         <div className="ant-upload-text">上传</div>
	       </div>
	     );
		 

		     <Button>
		       <IconFont type="iconupload-Lined" /> 上传
		     </Button>
		  
		   
		 
		 var max = 100;
		 			 
		 					if( (this.props.component.cp.maxNum)) {
		 						max = parseInt(this.props.component.cp.maxNum);
		 					}
		 				 
		 				 


	  return (
	       <div className="clearfix">
					 {
						 listType === 'drag' ? 
						 <Dragger
							accept={acceptStr}
							action={this.state.actionUrl}
							fileList={this.state.fileList}
							onPreview={this.handlePreview}
							onChange={this.handleChange}

							showUploadList={{showRemoveIcon:this.props.editable !==false , showPreviewIcon:true, showDownloadIcon:true}}

						>
							<p className="ant-upload-drag-icon">
								<InboxOutlined />
							</p>
							<p className="ant-upload-text">
							{this.props.component.cp.description}
							</p>

						</Dragger> : <Upload
							accept={acceptStr}
							action={this.state.actionUrl}
							listType={listType ? listType : "picture-card"}
							fileList={this.state.fileList}
							onPreview={this.handlePreview}
							onChange={this.handleChange}
							//showUploadList={{showRemoveIcon:this.props.editable !==false , showPreviewIcon:true, showDownloadIcon:true}}
							showUploadList={false}

						>
							{ this.props.editable !==false  && (this.state.fileList.length >= max ? null : (listType ==='text'? <Button type="primary"> {this.props.component.cp.description}

							</Button>
							:
							uploadButton))}
						</Upload>
					 }
	       </div>
	     );
	}
}



 